import bem from 'utils/bem';

export const block = bem('eddy-edit-transcript-modal');
